import request from '@/utils/request'

export function getBranches(size, page, find) {
  return request({
    url: `/general/branches`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function getBranchById(id) {
  return request({
    url: `/general/branches/id/${id}`,
    method: 'get'
  })
}

export function createBranches(data) {
  return request({
    url: `/general/branches/create`,
    method: 'post',
    data
  })
}

export function updateBranches(id, data) {
  return request({
    url: `/general/branches/id/${id}`,
    method: 'put',
    data
  })
}

export function removeBranches(id) {
  return request({
    url: `/general/branches/id/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/branch.js